<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Upload new Registration Numbers with Legal Obligation Excel file
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="large-12 medium-12 small-12 cell">
              <b-field>
                <b-upload v-model="dropFiles" multiple drag-drop expanded>
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large"></b-icon>
                      </p>
                      <p>Drop your files here or click to upload</p>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <div class="tags">
                <span
                  v-for="(file, index) in dropFiles"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submitFile()"
        >
          Submit
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import RegistrationNumberService from "@/services/RegistrationNumberService";
// @group Customers
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      default: -1
    }
  },
  /*
      Defines the data used by the component
    */
  data() {
    return {
      registrationNumberService: new RegistrationNumberService(),
      isModalActive: false,
      file: {},
      dropFiles: []
    };
  },

  methods: {
    cancel() {
      this.$emit("close");
    },
    /*
        Submits the file to the server
      */
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
    submitFile() {
      this.registrationNumberService
        .upload(this.dropFiles[0], this.customerId)
        .then(resp => {
          if (resp.data.msg.length != 0) {
            this.$buefy.dialog.alert({
              title:
                "Registration Numbers with Legal Obligation Upload was unsuccessful !!!",
              message: resp.data.msg.join("\n"),
              type: "is-danger",
              hasIcon: true,
              icon: "times-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true
            });
          } else {
            this.$buefy.toast.open({
              message:
                "Registration Numbers with Legal Obligation was Successfully Uploaded!!",
              type: "is-success"
            });
            this.$emit("confirm");
          }
          this.isModalActive = false;
          this.dropFiles = [];
        })
        .catch(err => {
          this.$buefy.dialog.alert({
            title:
              "Registration Numbers with Legal Obligation Upload was unsuccessful !!!",
            message: err["response"]["data"]["detail"],
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          this.isModalActive = false;
          this.dropFiles = [];
        });
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.$emit("close");
      }
    }
  }
};
</script>
